import { render, staticRenderFns } from "./CommitComment.vue?vue&type=template&id=6ac27091&scoped=true&"
import script from "./CommitComment.vue?vue&type=script&lang=js&"
export * from "./CommitComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac27091",
  null
  
)

export default component.exports